<template>
  <div class="home">
    <main>
      <Header />

      <Main>
        <template #cards>
          <Loader v-if="loading" />
          <div class="cards__news" v-else>
            <div class="news__cards">
              <PostNews v-for="n in news" :key="n.id" :news="n" />
            </div>
          </div>
        </template>
      </Main>
    </main>
    <Footer />
  </div>
</template>

<script>
import { Main } from "@/components";
import { AuxiliaryHeader as Header } from "@/components/app/Headers";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "News",
  data: () => ({
    loading: true
  }),
  methods: mapActions(["fetchNews"]),
  computed: mapGetters(["news"]),
  mounted() {
    this.fetchNews().then(() => (this.loading = false));
  },
  components: {
    Header,
    Main,
    PostNews: () => import("@/components/app/Posts/PostNews")
  }
};
</script>
